<form [formGroup]="providerService.entity">
    <div class="grid">
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="fullName">
            <span class="p-error">*</span>Nombre Completo:
          </label>
          <input type="text" pInputText id="fullName" formControlName="fullName" placeholder="Agencia Automotriz Velmonte" />
          <ng-container *ngIf="e.get('fullName')?.invalid && (e.get('fullName')?.dirty || e.get('fullName')?.touched)">
            <small class="p-error" *ngIf="e.get('fullName')?.errors?.['required']">El nombre completo es obligatorio.</small>
            <small class="p-error" *ngIf="e.get('fullName')?.errors?.['minlength']">El nombre debe tener al menos {{e.get('fullName')?.errors?.['minlength']['requiredLength']}} caracteres.</small>
          </ng-container>
        </div>
      </div>
  
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="rfc">
            <span class="p-error">*</span>RFC:
          </label>
          <input type="text" pInputText id="rfc" formControlName="rfc" placeholder="AAV123456789" />
          <ng-container *ngIf="e.get('rfc')?.invalid && (e.get('rfc')?.dirty || e.get('rfc')?.touched)">
            <small class="p-error" *ngIf="e.get('rfc')?.errors?.['required']">El RFC es obligatorio.</small>
            <small class="p-error" *ngIf="e.get('rfc')?.errors?.['pattern']">El RFC debe tener un formato válido.</small>
          </ng-container>
        </div>
      </div>
  
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="sector">
            <span class="p-error">*</span>Sector:
          </label>
          <input type="text" pInputText id="sector" formControlName="sector" placeholder="Automotriz" />
          <ng-container *ngIf="e.get('sector')?.invalid && (e.get('sector')?.dirty || e.get('sector')?.touched)">
            <small class="p-error" *ngIf="e.get('sector')?.errors?.['required']">El sector es obligatorio.</small>
          </ng-container>
        </div>
      </div>

      <div class="col-12 md:col-6" *ngIf="providerService.formMethod === 'EDIT'">
        <div class="field">
          <label for="status">
            <span class="p-error">*</span>Estatus:
          </label>
          <p-dropdown formControlName="status" [options]="statuses" optionLabel="label" optionValue="value" placeholder="Selecciona un estatus">
          </p-dropdown>
          <ng-container *ngIf="e.get('status')?.invalid && (e.get('status')?.dirty || e.get('status')?.touched)">
            <small class="p-error" *ngIf="e.get('status')?.errors?.['required']">El estatus es obligatorio.</small>
          </ng-container>
        </div>
      </div>
  
      <div class="col-12 md:col-6">
        <div class="field">
          <label for="subSector">
            <span class="p-error">*</span>Subsector:
          </label>
          <input type="text" pInputText id="subSector" formControlName="subSector" placeholder="Autopartes" />
          <ng-container *ngIf="e.get('subSector')?.invalid && (e.get('subSector')?.dirty || e.get('subSector')?.touched)">
            <small class="p-error" *ngIf="e.get('subSector')?.errors?.['required']">El subsector es obligatorio.</small>
          </ng-container>
        </div>
      </div>

    </div>
  </form>
  
